import React, { useEffect, useRef } from 'react';
import './RecordingVolumeMeter.css';

type RecordingVolumeMeterProps = {
  signalStrengthRef: React.MutableRefObject<number>;
};

const RecordingVolumeMeter: React.FC<RecordingVolumeMeterProps> = ({ signalStrengthRef }) => {
  const barRef: React.RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let animationFrameId: number;

    const updateHeight = () => {
      if (barRef.current) {
        const strength = signalStrengthRef.current;
        barRef.current.style.height = `${strength}%`;
      }
      animationFrameId = requestAnimationFrame(updateHeight);
    };
    animationFrameId = requestAnimationFrame(updateHeight);

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <div className='rec-vol-meter'>
      <div ref={barRef} className='rec-vol-meter-bar' />
    </div>
  );
};

export default RecordingVolumeMeter;
